import Headroom from 'headroom.js';

export default Headroom;
